<div class="message" [ngClass]="isError() ? 'error' : message().role">
  @for (part of message().parts; track $index) {
    @switch (part.type) {
      @case ('text') {
        @if (_displayLabel(); as label) {
          <div class="markdown">{{ label }}</div>
        } @else {
          @for (seg of segments(part.text); track $index) {
            @if (seg.type === 'copy') {
              <app-copyable-block
                [text]="seg.text"
                [html]="seg.html"
                [variant]="message().role"
              />
            } @else {
              <div
                class="markdown"
                [innerHTML]="seg.html"
                (click)="onMarkdownClick($event)"
              ></div>
            }
          }
          @if (hasHtmlBlock(part.text)) {
            <button
              class="html-preview-button"
              type="button"
              (click)="openHtmlPreview(part.text)"
            >
              📄 {{ chatWordings.previewHtml() }}
            </button>
          }
        }
      }
      @case ('reasoning') {
        <details>
          <summary>{{ chatWordings.reasoning() }}</summary>
          <div class="reasoning-content">
            <div>{{ part.text }}</div>
          </div>
        </details>
      }
      @case ('data-thought') {
        <!-- data-thought parts are aggregated and displayed separately -->
      }
      @case ('data-status') {
        <!-- data-status parts are handled by the agent-status component -->
      }
      @case ('data-trace') {
        <!-- handled in footer next to timestamp -->
      }
      @case ('data-cta') {
        <app-cta-buttons [part]="part" [streaming]="streaming()" />
      }
      @case ('data-question') {
        <app-question-options
          [part]="part"
          [streaming]="streaming()"
          (optionSelected)="questionAnswered.emit($event)"
        />
      }
      @case ('data-navigate') {
        <app-navigate-confirm
          [part]="part"
          [streaming]="streaming()"
          [skipConfirm]="navigateSkipConfirm()"
          (decisionMade)="navigateDecided.emit($event)"
          (skipConfirmChange)="navigateSkipConfirmChange.emit($event)"
        />
      }
      @case ('data-quota-warning') {
        <app-quota-warning [part]="part" />
      }
      @case ('data-degraded') {
        <app-degraded-notice [part]="part" />
      }
      @case ('data-result') {
        <app-result-block [part]="part" />
      }
      @case ('data-citation') {
        <app-citation-sources [part]="part" />
      }
      @case ('data-approval') {
        <app-approval-confirm
          [part]="part"
          [streaming]="streaming()"
          [superseded]="superseded()"
          (confirmed)="approvalConfirmed.emit($event)"
          (cancelled)="approvalCancelled.emit()"
        />
      }
      @case ('data-file') {
        @if (toFilePart(part); as filePart) {
          <app-file-attachment
            [file]="filePart"
            [variant]="message().role"
            (download)="fileDownload.emit(filePart)"
          />
        }
      }
      @case ('file') {
        @if (message().role === 'user') {
          <app-file-attachment
            [file]="part"
            [variant]="message().role"
            (download)="fileDownload.emit(part)"
          />
        }
      }
    }
  }

  @if (_debrief(); as debriefHtml) {
    <div class="debrief" [innerHTML]="debriefHtml"></div>
  }

  @if (showStatus()) {
    <app-agent-status [statusText]="statusText()" />
  }

  <div class="message-footer">
    @if (isError()) {
      <button
        class="retry-button"
        type="button"
        (click)="retryRequested.emit()"
      >
        <i class="myre-icon-refresh"></i>
        {{ chatWordings.retry() }}
      </button>
    }
    @if (_traceId()) {
      <button
        class="trace-link-button"
        type="button"
        [attr.title]="
          isAdmin()
            ? null
            : _traceCopied()
              ? chatWordings.copied()
              : chatWordings.traceReference()
        "
        (click)="onTraceClick()"
      >
        {{ _traceCopied() ? chatWordings.copied() : chatWordings.trace() }}
      </button>
    }
    @if (_copyableText() && !streaming()) {
      <button
        class="copy-button"
        type="button"
        [attr.aria-label]="chatWordings.copyMessage()"
        [attr.title]="
          _copied() ? chatWordings.copied() : chatWordings.copyMessage()
        "
        (click)="copyMessage()"
      >
        <i [class]="_copied() ? 'myre-icon-check' : 'myre-icon-copy'"></i>
      </button>
    }
    @if (streaming()) {
      <span class="streaming-indicator">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </span>
    } @else {
      <app-message-timestamp [timestamp]="formattedTimestamp()" />
    }
  </div>
</div>
